import React, { useState } from 'react';
import { Toast, Text } from '@lana-ui/common';
import TextLogin from '../../Components/Common/login/src/textLogin/TextLogin';
import InputBox from '../../Components/Common/common/src/inputBox/InputBox';
import InputGroup from '../../Components/Common/common/src/inputGroup/InputGroup';
import Label from '../../Components/Common/Formik/Label';
import RadioInput from '../../Components/Common/common/src/radioButton/RadioButton';
import Link from '../../Components/Common/common/src/link/Link';
import { Button } from '@lana-ui/login';
import PhonesBanner from '../../Components/Common/banner/PhonesBanner';
import '../../Statics/Scss/Pages/domiciliosGuardados.scss';
import GetParamURL from '../../Helpers/GetParamURL';

const DomiciliosGuardados = ({ errorMessage = true, state, send }) => {
    const [showToastPagoConfirmado, setShowToastPagoConfirmado] = useState(true);
    const domiciliosDisponibles = state.context.domicilio;
    const planCampania = state.context?.planCampania;
    const urlParams = GetParamURL();
    const domicilioPrincipal = domiciliosDisponibles?.find((domicilio) => domicilio.DomicilioPrincipal === true);
    const [domicilioSeleccionado, setDomicilioSeleccionado] = useState(domicilioPrincipal ? domicilioPrincipal.Id : null);
    
    const handleNuevoDomicilio = () => {
        send('CONTINUAR', { agregarDomicilio: true });
    };

    const handleFinalizar = () => {
        const payloadDomicilio = domiciliosDisponibles.find((d) => d.Id === domicilioSeleccionado);
        const payload = {
            IdCanalVenta: parseInt(urlParams.canalDeVenta),
            PlanId: planCampania.id,
            CorrelationId: state.context.dataVenta?.ventaResponse?.CorrelationId,
            EditarDomicilio: {
                addressId: payloadDomicilio.Id,
                altura: payloadDomicilio.Altura,
                calle: payloadDomicilio.Calle,
                cp: payloadDomicilio.CodigoPostal,
                dpto: payloadDomicilio.Dpto,
                entreCalle1: payloadDomicilio.EntreCalle1,
                entreCalle2: payloadDomicilio.EntreCalle2,
                localidad: payloadDomicilio.EntreCalle2,
                pais: 'ARGENTINA',
                piso: payloadDomicilio.Piso,
                provincia: payloadDomicilio.Provincia,
                torre: payloadDomicilio.Torre,
                cuerpo: payloadDomicilio.Cuerpo,
                lote: '',
                observaciones: payloadDomicilio.Observaciones,
                tipoDePropiedad: payloadDomicilio.TipoDePropiedad,
                normalizada: true,
            },
        };
        send('SUBMIT', { dataDomicilio: payload });
    };
    
    const handleValue = (e) => {
        setDomicilioSeleccionado(e.target.value);
    };
    return (
        <div className="domicilios-guardados">
            {showToastPagoConfirmado && (
                <Toast
                    status={'success'}
                    title="¡Listo!"
                    type={'toast'}
                    value={showToastPagoConfirmado}
                    closeAuto={true}
                    close
                    className="--roboto"
                    changeValue={() => setShowToastPagoConfirmado(false)}
                >
                    ¡Tu pago se realizó con éxito!
                </Toast>
            )}

            <TextLogin
                className="--mb-32"
                title={
                    <>
                        ¡Estás a un solo paso de tener tu credencial
                        <span className="ln"> Club LA NACION!</span>
                        <br />
                        ¿Dónde la querés recibir?{' '}
                    </>
                }
            >
                <Text as="p" size="4xs">
                    Sólo pueden ingresarse domicilios de Argentina.
                </Text>
            </TextLogin>
            <div className="inputs">
                <InputGroup className={'--mb-4'}>
                    <Label text={'Tus domicilios guardados'} />
                    {domiciliosDisponibles.map((domicilio) => {
                        return (
                            <>
                                <InputBox
                                    className="--mb-8"
                                    // error={formState.error}

                                    input={
                                        <RadioInput
                                            onChange={handleValue}
                                            value={domicilio.Id}
                                            checked={domicilioPrincipal && !domicilioSeleccionado ? domicilioPrincipal.Id === domicilio.Id : domicilio.Id === domicilioSeleccionado}
                                        >
                                            {domicilio.Calle} {domicilio.Altura} {domicilio.Localidad}
                                            {' - '}
                                            {domicilio.Provincia} {domicilio.CodigoPostal}
                                        </RadioInput>
                                    }
                                />
                            </>
                        );
                    })}
                </InputGroup>
                <Link text={'+ Agregar nuevo'} onClick={handleNuevoDomicilio} />
            </div>
            <Button disabled={!domicilioSeleccionado} className="--not-disabled --mb-16" label="Finalizar" onClick={handleFinalizar} />
            <PhonesBanner notSuscribe={true} />
        </div>
    );
};
export default DomiciliosGuardados;
